export default "__VITE_ASSET__DLYjVNHB__"